/**
 * Module 67 (WP-67.B4) — Gate Widener: the tapped gate is one cell wider for
 * the rest of the level.
 *
 * The first `'target-gate'` effect — `'target'`'s flow aimed at gates instead
 * of blocks, because the thing it changes is an EXIT and block ids cannot
 * address it. The rule itself lives in `model/widen-gate.ts` (growth side,
 * bounds, the no-shared-lanes wall invariant); this file only plugs it into
 * the power-up seam.
 *
 * `gateTargets` returns only gates that CAN widen, so a full-wall gate or one
 * boxed in by neighbours is dimmed like an invalid block target — the player
 * is never sold a no-op, and the arm refuses outright when no gate qualifies.
 *
 * The widen persists in `puzzle.exits`: it survives undo (undo restores
 * blocks, never puzzle geometry — a paid effect must not be undone for free),
 * survives a mid-level save/reload, and resets with the board on restart —
 * the same per-attempt semantics as Surge's spent flag and the ad-move
 * allowance.
 */
import { BlockJamAudioId } from '../../constants/audio-ids';
import { widenableGateKeys, widenGate } from '../../model/widen-gate';
export const GATE_WIDENER_ID = 'gateWidener';
export const gateWidenerEffect = {
    activation: 'target-gate',
    gateTargets(state) {
        return widenableGateKeys(state);
    },
    applyToGate(state, gateKey) {
        return widenGate(state, gateKey);
    },
    /** Unreachable for a `'target-gate'` effect — targets are gates, not blocks. */
    targets() {
        return [];
    },
    /** Unreachable for a `'target-gate'` effect. */
    apply() {
        return null;
    },
    /** The gate growing IS the effect — the cue rides that repaint. */
    impactAudioId: BlockJamAudioId.POWERUP_WIDENER,
};
